import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from './router'
import vuetify from "./plugins/vuetify";
// import 'lib-flexible/flexible'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
// import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullpage from 'vue-fullpage.js'
import VueI18n from 'vue-i18n'
import './util/rem'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(VueI18n)

// 创建实例 - 根据本地语言加载多语言文件
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh-CN',
  messages: {
    'zh-CN': require('@/util/zh_CN'),
    'en-US': require('@/util/EN'),
  }
})

// Vue.prototype.$ctx = 'http://115.159.43.117:8080/nong-website-api/uploaded/image/';
Vue.prototype.$ctx = 'http://www.nong-studio.com:80/nong-website-api/uploaded/image/';


Vue.use(VueFullpage)
Vue.config.productionTip = false;

new Vue({
  router,
  i18n,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
